<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu v-bind:value="isShowMenu">
      <template slot="trigger">
        <div class="tooth__body">
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
          <button
            class="tooth__body__gingiva"
            type="button"
            v-bind:class="{ selected: isSelected('gingiva') }"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onClick('all', $event)" />
          <svg
            v-if="!isDeleted"
            class="tooth__parts"
            fill="none"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M29.8002 48.5688C29.8002 52.2174 28.0649 63.9085 27.8452 69.3919L45.0436 71.3701C44.9102 62.2426 44.455 40.4686 43.701 26.3921C42.9471 12.3157 34.9003 4.51766 32.7405 1.84536C32.3871 1.29008 31.4211 0.720917 30.3845 2.88652C24.5909 14.9892 31.089 29.7777 30.0882 43.1583C29.9288 45.2895 29.8002 47.1635 29.8002 48.5688Z"
              v-bind:class="{ selected: isSelected('root_1') }"
              v-bind:fill="partColor['root_1'] || '#FFF'"
              v-on:click="onClick('root_1', $event)"
              v-on:keydown="onClick('root_1', $event)" />
            <path
              d="M40.5991 55.6818L40.6603 55.4901C40.7804 55.1137 40.7997 54.7149 40.7184 54.3283C37.9119 40.9751 37.1554 24.1742 36.4745 20.1351C36.4185 19.8029 36.2479 19.5151 36.0065 19.28C35.7338 19.0143 35.3272 18.8509 35.0571 19.1192C34.8268 19.3481 34.6115 19.7831 34.6301 20.6099C34.9063 32.9216 35.0963 47.7514 34.1228 54.7188L34.0228 55.5045C33.9802 55.8389 34.0633 56.1772 34.256 56.4538C34.433 56.7079 34.6913 56.8939 34.9883 56.9813L35.3185 57.0785L36.2256 57.1586L37.5732 57.1056C37.8989 57.0928 38.2233 57.0569 38.544 56.9982L39.1247 56.8919C39.264 56.8664 39.401 56.8297 39.5344 56.7822C40.0416 56.6016 40.4353 56.1946 40.5991 55.6818Z"
              v-bind:class="{ selected: isSelected('central_canal') }"
              v-bind:fill="partColor['central_canal'] || '#FF82BE'"
              v-on:click="onClick('central_canal', $event)"
              v-on:keydown="onClick('central_canal', $event)" />
            <path
              d="M44.879 97.3998L29.3172 97.4987C28.7764 97.5022 28.2364 97.4565 27.7038 97.3624C27.4523 97.318 27.2024 97.26 26.9801 97.1342C26.5818 96.9088 25.9143 96.4083 25.3832 95.3978C24.7432 94.1803 24.7198 92.7537 24.7477 91.3785C24.833 87.176 25.2765 79.9114 26.6194 73.349C26.925 71.8553 27.3471 70.5424 27.8452 69.3927C29.6481 65.231 32.4481 63.2063 34.3363 62.4752C34.9095 62.2533 35.5287 62.2087 36.1433 62.2087C37.3222 62.2087 38.5092 62.411 39.4937 63.0597C41.1495 64.1508 43.2557 66.1121 44.29 68.9762C44.5464 69.6864 44.799 70.4988 45.0435 71.3709C46.1467 75.3056 46.7285 80.5603 47.1142 83.0318C47.1535 85.9818 47.5649 92.2981 47.4707 94.3804C47.419 95.5215 47.1056 96.2769 46.7553 96.7496C46.3366 97.3146 45.5822 97.3998 44.879 97.3998Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <top-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-bind:flip="flip"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import TopToothSurface from '../TopToothSurface.vue';

export default {
  components: {
    ToothPopoverMenu,
    FormTeethFormulaDiagnoses,
    TopToothSurface,
  },
  mixins: [toothMixin],
  name: 'ToothUp2',
};
</script>

<style></style>
